import React from 'react';
import PropTypes from 'prop-types';
import { AppState } from '../state/MyStateProvider';
import { APP_STATE_ACTION_TYPE_USER_FONT, APP_STATE_ACTION_TYPE_USER_FONT_SIZE } from '../state/seed-states';
import {
  seedDefaultFont,
  seedSupportedFonts,
  seedDefaultFontSize,
  seedSupportedFontSizes,
} from './seed-fonts';

const MyFontProvider = (props) => {
  const {
    children,
    fontSupportedFonts,
    fontDefaultFont,
    fontSupportedFontSizes,
    fontDefaultFontSize,
  } = props;
  const { state } = React.useContext(AppState);
  const userFont = state[APP_STATE_ACTION_TYPE_USER_FONT];
  const userFontSize = state[APP_STATE_ACTION_TYPE_USER_FONT_SIZE];

  let font = fontDefaultFont;
  if (userFont && fontSupportedFonts.includes(userFont)) {
    font = userFont;
  }

  let fontSize = fontDefaultFontSize;
  if (userFontSize && fontSupportedFontSizes.includes(userFontSize)) {
    fontSize = userFontSize;
  }

  return (
    <>
      {React.cloneElement(children, {
        font,
        fontSize,
      })}
    </>
  );
};

MyFontProvider.propTypes = {
  children: PropTypes.node.isRequired,
  fontSupportedFonts: PropTypes.arrayOf(PropTypes.string),
  fontDefaultFont: PropTypes.string,
  fontSupportedFontSizes: PropTypes.arrayOf(PropTypes.number),
  fontDefaultFontSize: PropTypes.number,
};

MyFontProvider.defaultProps = {
  fontDefaultFont: seedDefaultFont,
  fontSupportedFonts: seedSupportedFonts,
  fontDefaultFontSize: seedDefaultFontSize,
  fontSupportedFontSizes: seedSupportedFontSizes,
};

export default MyFontProvider;
